export default __webpack_public_path__ + "static/media/white-logo.8357301d.svg";